import Cookie from '@gifsa/cookie-utils'
import { setUser, setContext } from '@sentry/vue'

export default defineNuxtPlugin({
  name: 'cookie',
  setup() {
    const logger = useLogger('plugin:cookie')
    try {
      const cookieStr = import.meta.server ? useRequestHeaders(['cookie']).cookie : document.cookie
      if (!cookieStr && !import.meta.prerender) {
        logger.warn('No cookie string found')
      }
      const cookie = new Cookie(cookieStr ?? '')
      setUser({ id: cookie.getId() })
      setContext('cookie', {
        abGroup: cookie.getAbGroup(),
        lang: cookie.getLang(),
        geoLoc: cookie.getGeoLoc(),
      })
      return { provide: { cookie: ref(cookie) } }
    } catch (e) {
      logger.error(e)
      throw e
    }
  },
})
